export enum EtatDecisionJury {
    ETAT_NON_VALIDE,
    ETAT_VALIDE,
    ETAT_A_REVALIDER,
}
